import { useState } from 'react';
import { useBoolean } from 'ahooks';
import {
  Button, Col, Input, message, Row,
} from 'antd';
import { AxiosError } from 'axios';

import { apiGet } from 'api';

import { Container } from 'components';

import { useGetHeaders, usePutRequest } from 'hooks';

export const CollectorNumberInput = () => {
  const [value, setValue] = useState('');

  const [loading, { setTrue, setFalse }] = useBoolean(false);

  const [handlePut] = usePutRequest({
    url: '/collectors/fraud/unmark',
    options: {
      onSuccess: () => message.success(`Collector ${value} is not a fraudster anymore`),
    },
  });

  const headers = useGetHeaders();

  const downloadCSV = async () => {
    try {
      setTrue();
      const response = await apiGet<string>({ url: '/collectors/fraud/export', headers });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const href = window.URL.createObjectURL(blob);

      const contentDisposition = response.headers['content-disposition'];

      const filename = contentDisposition ? contentDisposition.replace('attachment; filename=', '').replaceAll('"', '') : 'Fraudster_Collectors';

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      message.error(error.response?.data.message);
    } finally {
      setFalse();
    }
  };

  return (
    <Container className='flex-none'>
      <h2 className='mb-10'>Collectors</h2>

      <Row className='mb-10'>
        <Col xs={16}>
          <Row wrap={false} gutter={10}>
            <Col xs={14}>
              <Row wrap={false} align='middle'>
                <Col xs={12}>
                  <span>Collector Number</span>
                </Col>

                <Input
                  value={value}
                  maxLength={11}
                  onChange={({ target }) => setValue(target.value)}
                />

              </Row>

            </Col>

            <Col flex={1}>
              <Button
                onClick={() => handlePut({ callbackQueryParams: { collectorNumber: value } })}
                disabled={!value}
              >
                Unmark fraudster collector
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Button
          type='primary'
          onClick={downloadCSV}
          loading={loading}
        >
          Download fraudster collectors
        </Button>
      </Row>
    </Container>
  );
};
